import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-cloud",
  "use": "icon-si-glyph-cloud-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-cloud\" id=\"icon-si-glyph-cloud\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>849</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M13.797,7.445 C13.547,7.445 13.31,7.513 13.084,7.613 C12.39,6.577 11.252,5.899 9.965,5.899 C9.759,5.899 9.558,5.921 9.36,5.955 C8.678,4.826 7.491,4.075 6.135,4.075 C4.225,4.075 2.645,5.566 2.356,7.513 C2.338,7.513 2.322,7.509 2.305,7.509 C1.024,7.509 -0.013,8.613 -0.013,9.976 L15.987,9.976 C15.848,8.551 14.926,7.445 13.797,7.445 L13.797,7.445 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-cloud.svg
// module id = uWR5
// module chunks = 62